export default __webpack_public_path__ + "static/media/05.4c0ebeb7.png";